module.exports = __webpack_public_path__ + "static/card-project2-93b1cec58542e511f6798c3c38df9c7f.jpg";